<template>
  <v-container>
    <v-row
      justify="center"
    >
      <v-col
        cols="12"
        sm="12"
        md="6"
        lg="4"
      >
        <router-link :to="{ name: 'ListReference' }">< Retour au catalogue</router-link>
        <h1 class="display-1 pb-4 ml-5 d-inline-block">Réf. {{ reference.name }}</h1>
        <v-img :src="reference.thumbnail"></v-img>
      </v-col>
      <v-col
        cols="12"
        sm="12"
        md="6"
        lg="5"
      >
        <v-row>
          <v-col class="pt-2">
            <h2 class="pb-4 pl-3">{{ reference.description }}</h2>
            <Table :reference="reference" slot="table"></Table>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <v-row
      justify="center"
    >
      <v-col
        cols="12"
        sm="12"
        md="6"
        lg="9"
      >
        <span class="font-weight-bold">Description</span>
        <br>
        <br>
        <p>{{ reference.description }}</p>
        <br>
        <div class="description" v-html="reference.productDesc"></div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  // COMPONENTS
  import Table from './Table'
  // EVENTTS
  import { EventBus } from '@/main.js'
  import { AUTH_LOGOUT } from '@/store/actions/auth'
  import { LOADING, LOADED } from '@/store/actions/general'
  // REPOSITORIES
  import { RepositoryFactory } from '@/repositories/RepositoryFactory.js'
  const ReferencesRepository = RepositoryFactory.get('references')

  export default { 
    name: 'Show',

    components: {
      Table,
    },

    data: () => ({
      reference: {},
      errors: [],
      isLoading: false,
    }),

    methods: {
      async getReference(id) {
        this.isLoading = true
        let customerApiToken = this.$store.getters.getCustomer.apiToken
        await ReferencesRepository
          .getReference(id, customerApiToken)
          .then(response => {
            this.isLoading = false
            this.reference = response.data
            EventBus.$emit(LOADED)
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 403) {
                this.$store
                  .dispatch(AUTH_LOGOUT)
                  .then(() => {
                    this.$router.push('/login').catch(err => {})
                  })
              }
            }
          })
      },
    },

    created() {
      EventBus.$emit(LOADING, 'Chargement de la référence...')
      this.getReference(this.$route.params.id)
    }
  }
</script>

<style lang="scss" scoped>
  @import '@/styles/variables.scss';
  .v-application .display-1 {
    font-family: $body-font-family;
  }
</style>
<style>
  .description table {
    max-width: 200px !important;
  }
</style>